import { createSlice } from "@reduxjs/toolkit";
// ⚠️ Deep-imports the DESKTOP variant on purpose — hazard 6. `userLogout`/`supportLogout`
// are web-only, and a bare `../LoginSlice` typechecks against the NATIVE variant because
// packages/core's tsconfig sets `moduleSuffixes: [".native", ".shared", ".desktop", ""]`.
import { supportLogout, userLogout } from "../LoginSlice";
import { sharedInitialState, sharedReducers } from "./shared";
import type { SharedLocalServer } from "./shared";

// Not exported, and lowercase — matches the apps.
interface localServer extends SharedLocalServer {}

const initialState: localServer = {
  ...sharedInitialState,
}

export const localServerSlice = createSlice({
  name: 'localServer',
  initialState,
  reducers: {
    ...sharedReducers,
    // Web-only.
    updateLocalServerSlice: (state, action) => {
      return action.payload;
    }
  },
  // Both bodies are empty in the app source — the cases exist but reset nothing.
  // Preserved as-is; giving them a body would be a behaviour change, not a fix.
  extraReducers: (builder) => {
    builder
      .addCase(userLogout, (state) => {

      })
      .addCase(supportLogout, (state) => {

      });
  },
});

export const {
  callLocalServerMaster,
  callLocalServerMasterSuccess,
  callSyncStart,
  callSyncStop,
  syncSale,
  syncSaleSuccess,
  saveUnSyncedSale,
  fetchServerSaleData,
  setNetworkStatus,
  updateLocalServerSlice
} = localServerSlice.actions;

export default localServerSlice.reducer;
